<form id="usuario_form" name="usuario_form" novalidate ng-submit="save(usuario_form)">
  <ng-include src="'views/usuarios/_usuario_detalhes.html'"></ng-include>
  <div class="row pull-right padding-top-10" ng-include="'views/usuarios/_usuario_buttons.html'"></div>
</form>